import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { App } from '@app/App.tsx';
import { AlertProvider } from '@components/Alert/AlertProvider.tsx';
import { ToastProvider } from '@components/Toast/Toast.tsx';
import './i18n';
import reportWebVitals from './reportWebVitals.ts';
import '@scss/index.scss';
import { store } from '@state/configureStore.ts';

const mockEnabled = import.meta.env.VITE_ENABLE_MOCKS;

const startApp = async () => {
    if (mockEnabled === 'true' || mockEnabled === true) {
        try {
            const { worker } = await import('@mocks/browser');
            await worker.start();
        } catch (err) {
            console.error('Failed to load mocks:', err);
        }
    }

    const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
    root.render(
        <BrowserRouter>
            <Provider store={store}>
                <ToastProvider>
                    <AlertProvider>
                        <App />
                    </AlertProvider>
                </ToastProvider>
            </Provider>
        </BrowserRouter>,
    );

    reportWebVitals();
};

startApp();
